import { API } from "apis";
import Image from "components/common/images/Image";
import { ContextModel, ThreadMessageModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";
import React from "react";
import { BiDownload } from "react-icons/bi";
import { FaRegFileAlt } from "react-icons/fa";
import { Utils } from "utils";

type PROPS = {
  ctx: ContextModel;
  opponentCorpId: string; // 相手のcorpID
  data: ThreadMessageModel;
};

const MessageItem: React.FC<PROPS> = (props) => {
  const ctx = props.ctx;
  const opponentCorpId = props.opponentCorpId;
  const data = props.data;

  const onDownload = async (message_id: string, file: CommonFileModel) => {
    ctx.loading.setState(true);
    try {
      const response = await API.ThreadMessage.download(
        message_id,
        file.seq_no!
      );
      console.log(response);
      if (response) {
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        let fileName = "download";
        if (response.headers && "content-disposition" in response.headers) {
          const cd = response.headers["content-disposition"];
          console.log(`content-disposition: ${cd}`);
          if (cd) {
            const matcher0 = cd.match(/.*filename\*=utf-8''(.+)/);
            if (matcher0 && matcher0.length > 0) {
              fileName = decodeURI(matcher0[1]);
            } else {
              const matcher = cd.match(/.*filename="(.+)"/);
              if (matcher && matcher.length > 0) {
                fileName = matcher[1];
              }
            }
          }
        }
        link.download = fileName;

        // content-disposition: attachment; filename="item_category.png"
        link.href = URL.createObjectURL(blob);
        link.click();
        URL.revokeObjectURL(link.href);
      }
    } catch (err) {
      Utils.errorAction(ctx, err);
    }
    ctx.loading.setState(false);
  };

  let attachments = <></>;
  const files = data.message_append_file_list;
  if (files && files.length > 0) {
    attachments = (
      <div className="m-2 grid grid-cols-2 gap-4">
        {files.map((file, index) => (
          <div
            key={index}
            className="border border-black p-2 flex items-center gap-4"
          >
            <div>
              <FaRegFileAlt className="text-jhk-blue text-3xl" />
            </div>
            <div
              className="flex-1 text-left overflow-hidden text-ellipsis"
              title={file.file_name}
            >
              {file.file_name}
            </div>
            <button
              onClick={() => {
                onDownload(data.message_id, file);
              }}
            >
              <BiDownload className="text-3xl" />
            </button>
          </div>
        ))}
      </div>
    );
  }

  const opponent = data.message_send_corp_id === opponentCorpId;

  return (
    <div className="mx-4 my-8 flex items-start gap-4">
      <div className="w-24">
        {opponent && data?.message_send_corp_logo_image?.image_url && (
          <div className="">
            <Image
              data={data.message_send_corp_logo_image}
              height="100px"
            />
          </div>
        )}
      </div>
      <div
        className="flex-1 rounded p-4 drop-shadow-lg border border-gray-400  max-w-[calc(98vw_-_32rem)]"
        style={{
          backgroundColor: `${opponent ? "white" : "rgb(246,249,251)"}`,
        }}
      >
        <div className="whitespace-pre-line break-words">{data.message}</div>
        {attachments}
        <div className="flex gap-2 text-right text-gray-400">
          {!data?.message_send_corp_logo_image?.image_url && <span className="mr-5 truncate flex-1">{data.message_send_corp_name}</span>}
          {Utils.Date.format(data.message_send_datetime)}
        </div>
      </div>
      <div className="w-24">
        {!opponent && data?.message_send_corp_logo_image?.image_url && (
          <div className="">
            <Image
              data={data.message_send_corp_logo_image}
              height="100px"
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default MessageItem;
